import React from 'react';
import { PersonCardProps } from './PersonCardProps';
import { GatsbyImage } from 'gatsby-plugin-image';

import * as styles from './PersonCard.module.scss';
import classNames from 'classnames';

export const PersonCard: React.FC<PersonCardProps> = ({
	name,
	email,
	phone,
	position,
	sprite,
	qr,
}) => {
	return (
		<div className={classNames(styles.person, 'text-center')}>
			<div className={styles.imageBox}>
				<GatsbyImage
					className={styles.personImage}
					image={sprite}
					alt={name}
					objectPosition="top"
					imgClassName={styles.personImageImg}
				/>
				<div className={styles.qrCodeBox}>
					<GatsbyImage
						className={styles.qrCode}
						image={qr}
						alt={`QR-${name}`}
						objectFit="contain"
					/>
				</div>
				<div className={classNames(styles.contact, 'text-right')}>
					{phone && <div className={styles.contactTel}>{phone}</div>}
					<div className={styles.contactEmail}>{email}</div>
				</div>
			</div>
			<div className={styles.personInfo}>
				<div className={classNames(styles.personSignature, 'font-size-16')}>
					{name}
				</div>
				<div className={classNames(styles.personPosition, 'font-size-14')}>
					{position}
				</div>
				<div className={classNames(styles.personEmail, 'text-left')}>
					{email}
				</div>
			</div>
		</div>
	);
};
